import { render, staticRenderFns } from "./CompanyHome.vue?vue&type=template&id=7fbf2db4&"
import script from "./CompanyHome.vue?vue&type=script&lang=ts&"
export * from "./CompanyHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports